import s from './CustomButton.module.scss'

interface IButton extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  variant: 'primary' | 'secondary' | 'outlined' | 'danger' | 'success'
  small?: boolean
  className?: string
  size?: '40' |'87' | '152' | '180' | '240' | '280'
  testid?: string
}

export const CustomButton = (props: IButton) => {
  const { children, variant, small, className, size, testid, ...buttonProps } = props

  return (
    <button
      {...buttonProps}
      className={`${s.button} ${s[variant]} ${small && s.small} ${className || ''} ${size && s['size-' + size]}`}
      data-testid={testid}
    >
      {children}
    </button>
  )
}
